import { useEffect, useState } from "react";
import { useAnalytics } from "@/context/GoogleAnalyticsContext";
import {
  createCheckoutSession,
  transformPricePointsToItems,
} from "@/services/credits";
import { CreditType, EcommerceItem } from "@/models/models";
import { useCredits } from "@/context/CreditsContext";

import ButtonPushable from "../buttons/ButtonPushable/ButtonPushable";
import { SaleIcon } from "../icons/sale";
import { InfoIcon } from "../icons/info";

const CreditsForm = () => {
  const { sendAnalyticsRecord } = useAnalytics();
  const { getPricePointsByCreditType } = useCredits();
  const pricePoints = getPricePointsByCreditType(CreditType.minecraft);
  const itemList = transformPricePointsToItems(pricePoints);
  const [loadingItemId, setLoadingItemId] = useState<string | null>(null);

  useEffect(() => {
    sendAnalyticsRecord("view_item_list", { items: itemList });
  }, []);

  const handleClick = async (ecommerceItem: EcommerceItem) => {
    setLoadingItemId(ecommerceItem.item_id);
    const checkoutSession = await createCheckoutSession(ecommerceItem);
    sendAnalyticsRecord("begin_checkout", ecommerceItem);
    window.location.href = checkoutSession.url;
  };

  if (itemList.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-3 p-8 text-secondary-foreground">
        <InfoIcon className="w-10 h-10 opacity-80 [&_path]:fill-secondary-foreground mb-4" />
        <p className="text-base text-center font-poppins">
          No credit packages are available at this time. Please check back later.
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-8">
      {itemList.map((item) => (
        <ButtonPushable key={item.item_id} onClick={() => handleClick(item)} loading={loadingItemId === item.item_id} disabled={loadingItemId !== null}>
          <div className="relative w-full flex justify-between items-center gap-2">
            <img src="/images/coin.png" alt="image of coin" />
            <span className="font-poppins text-xl font-medium text-[#242C36]">
              {item.item_name} - ${item.price.toFixed(2)}
            </span>
            {item.sale && (
              <div className="absolute -right-[1.4em] top-[2.2em] rotate-[55deg]">
                <SaleIcon />
              </div>
            )}
          </div>
        </ButtonPushable>
      ))}
    </div>
  );
};

export default CreditsForm;
